<template>
	<header class="sticky top-0 z-40" :class="[group ? 'bg-group' : 'bg-bg', { 'border-b border-line': border }]" :style="{ paddingTop: 'var(--safe-t)' }">
		<div class="flex h-bar items-center px-1.5">
			<!-- Home: brand lockup -->
			<template v-if="variant === 'home'">
				<router-link to="/" class="flex min-h-tap flex-1 items-center gap-2 pl-2 text-ink" aria-label="In His Hands home">
					<img src="/icons/mark.svg" alt="" width="48" height="30" class="h-[30px] w-12" />
					<span class="text-[19px] font-extrabold tracking-[0.01em]">In His Hands</span>
				</router-link>
			</template>

			<!-- Tab root: large title -->
			<template v-else-if="variant === 'root'">
				<h1 class="min-w-0 flex-1 truncate pl-2.5 text-[26px] font-extrabold tracking-[-0.01em]">
					<slot name="title">{{ title }}</slot>
				</h1>
			</template>

			<!-- Pushed page: back + centred title -->
			<template v-else>
				<div class="flex min-w-[88px] items-center">
					<button v-if="back" type="button" class="icon-btn" :aria-label="closeIcon ? 'Close' : 'Back'" @click="goBack">
						<Icon :name="closeIcon ? 'close' : 'back'" :size="closeIcon ? 22 : 24" />
					</button>
				</div>
				<h1 class="min-w-0 flex-1 truncate text-center text-[17px] font-bold">
					<slot name="title">{{ title }}</slot>
				</h1>
			</template>

			<div class="flex items-center justify-end" :class="{ 'min-w-[88px]': variant === 'page' }">
				<slot name="actions" />
				<router-link v-if="create" :to="create" class="icon-btn bg-tint text-link" :aria-label="createLabel">
					<Icon name="plus" />
				</router-link>
				<router-link v-if="search" to="/search" class="icon-btn" aria-label="Search">
					<Icon name="search" />
				</router-link>
				<router-link v-if="bag" to="/cart" class="icon-btn" :aria-label="`Bag, ${bagCount} items`">
					<Icon name="bag" />
					<span v-if="bagCount" class="badge">{{ bagCount }}</span>
				</router-link>
			</div>
		</div>
		<slot name="below" />
	</header>
</template>

<script>
import Icon from './Icon.vue'
import { setStatusBarColor } from '@/lib/theme'

export default {
	components: { Icon },
	inject: ['store'],
	props: {
		variant: { type: String, default: 'page' }, // 'home' | 'root' | 'page'
		title: { type: String, default: '' },
		back: { type: Boolean, default: true },
		backTo: { type: String, default: '/' },
		closeIcon: { type: Boolean, default: false },
		search: { type: Boolean, default: false },
		bag: { type: Boolean, default: false },
		create: { type: [String, Object], default: null },
		createLabel: { type: String, default: 'Create' },
		group: { type: Boolean, default: false },
		border: { type: Boolean, default: true },
	},
	computed: {
		bagCount() {
			return this.store.cartTotalItems || 0
		},
	},
	mounted() {
		setStatusBarColor(this.group ? 'group' : 'bg')
	},
	activated() {
		setStatusBarColor(this.group ? 'group' : 'bg')
	},
	methods: {
		goBack() {
			// Use real history when there is some, so Back matches the system gesture.
			if (window.history.state?.back) this.$router.back()
			else this.$router.replace(this.backTo)
		},
	},
}
</script>

<style scoped>
.badge {
	position: absolute;
	top: 3px;
	right: 2px;
	min-width: 18px;
	height: 18px;
	padding: 0 5px;
	border-radius: 9px;
	background: rgb(var(--accent));
	color: rgb(var(--on-accent));
	font-size: 11px;
	font-weight: 800;
	display: flex;
	align-items: center;
	justify-content: center;
	box-shadow: 0 0 0 2px rgb(var(--bg));
}
</style>
